import { createFileRoute } from '@tanstack/react-router'
import EntityTypeRecurrencesTab from '@admin/preferences/entities/EntityTypeRecurrencesTab'

export const Route = createFileRoute('/_auth/preferences/entityTypes/$entityTypeId/recurrences')({
  component: RouteComponent,
})

function RouteComponent() {
  const { entityType } = Route.useRouteContext()

  return <EntityTypeRecurrencesTab entityType={entityType} />
}
